import React from 'react';
import { Helmet } from 'react-helmet';

import JoinContainer from './components/presentational/JoinContainer';
import BackgroundSlidesPageContainer from '../login/components/shared/BackgroundSlidesPageContainer';
import PageWrapper from '../login/components/shared/PageWrapper';
import useBackgroundSlides, { createLoginSlides } from '../login/components/hooks/useBackgroundSlides';

const slides = createLoginSlides(12);

const JoinOrganization = () => {
  const { imageTransition } = useBackgroundSlides(slides);

  return (
    <BackgroundSlidesPageContainer imageTransition={imageTransition}>
      <Helmet>
        <title>Join Organization | Teambuildr</title>
      </Helmet>
      <PageWrapper>
        <JoinContainer />
      </PageWrapper>
    </BackgroundSlidesPageContainer>
  );
};

export default JoinOrganization;
